import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import SelfCareToolTip from '../selfCareToolTip/SelfCareToolTip';
import toolTipIcon from './icons/toolTipIcon.svg';

const InternetPackageEnding = ({icon, text,btnCondition, btnText, btnCallBack, btbCallBackParam,showToolTip}) => {
  const toolTipText="פרטים אודות תעריפי חריגה אפשר למצוא בחשוב לדעת באזור החבילה שלי";
  return (
    <div className='internet-package-ending'>
      {icon && <Image className='icon' src={icon} alt='icon' />}
      {text && <span className='text' dangerouslySetInnerHTML={{__html: text}}></span>}
      {showToolTip && <SelfCareToolTip icon={toolTipIcon} text={toolTipText}/>}
      {btnCondition && btnText && (
        <BtnSubmit
          text={btnText}
          onclick={() => {
            if (btnCallBack) {
              btnCallBack(btbCallBackParam);
            }
          }}
        />
      )}
    </div>
  );
};

export default InternetPackageEnding;
